import { PqrSurvey } from '../../../../../shared/types/modules/pqr';
import { Question } from './props';

export const initialValues: PqrSurvey = {
    type: 'V1',
    question1: '',
    question2: '',
    question3: '',
    question4: '',
    question5: '',
    question6: '',
    question7: '',
    question8: '',
    question9: '',
    question10: '',
    question11: '',
    pqrId: '',
};

export const questionsV1: Question[] = [
    {
        id: 'question1',
        type: 'scale',
        text: "1. En general, ¿Qué tan satisfecho está con su experiencia de atención de PQR's?",
        options: ['1', '2', '3', '4', '5'],
        labels: ['Muy Insatisfecho', '', '', '', 'Muy Satisfecho'],
    },
    {
        id: 'question2',
        type: 'scale',
        text: "2. Por favor indíquenos su nivel de satisfacción relacionado con nuestro proceso de Atención de PQR's. ¿La respuesta fue clara y profesional por parte del área que atendía su PQR?",
        options: ['1', '2', '3', '4', '5'],
        labels: ['Muy Insatisfecho', '', '', '', 'Muy Satisfecho'],
    },
    {
        id: 'question3',
        type: 'scale',
        text: "3. Por favor indíquenos su nivel de satisfacción relacionado con nuestro proceso de Atención de PQR's ¿El Tiempo de resolución de su PQR fue el adecuado?",
        options: ['1', '2', '3', '4', '5'],
        labels: ['Muy Insatisfecho', '', '', '', 'Muy Satisfecho'],
    },
    {
        id: 'question4',
        type: 'scale',
        text: '4. En una escala (1 a 5) donde 1 es muy sencillo y 5 es muy difícil, por favor califique ¿Qué tan sencillo fue realizar el trámite de su pqr con nosotros?',
        options: ['1', '2', '3', '4', '5'],
        labels: ['Muy Sencillo', '', '', '', 'Muy Difícil'],
    },
    {
        id: 'question5',
        type: 'unique',
        text: '5. ¿Cuál es la mejora más importante, en caso de que pudiésemos ayudar a reducir la cantidad de esfuerzo que invirtió para resolver su PQR?',
        options: [
            'No Aplica',
            'No Informa',
            'Mejorar Tiempos De Respuesta Y Calidad Del Servicio',
            'Mejor Servicio',
            'Mas Personal Disponible',
            'Información Clara Y Oportuna',
            'Contestar el teléfono',
            'Claridad en la respuesta',
        ],
    },
    {
        id: 'question6',
        type: 'scale',
        text: "6. Basado en su experiencia en la atención de sus PQR's (Peticiones, Quejas o Reclamos) ¿Qué tan dispuesto estaría  usted de recomendar a Previsora Seguros a un familiar, amigo o colega?",
        options: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
        labels: [
            'Poco Probable',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            'Muy Probable',
        ],
    },
    {
        id: 'question7',
        type: 'textarea',
        text: '¿Cuál es la principal razón por la que da esta calificación?, ¿Tiene alguna mejora importante que debamos realizar?',
    },
    {
        id: 'question8',
        type: 'unique',
        text: '7. ¿Cuál es la principal razón por la cual nos dio este puntaje?',
        options: [
            'Buen servicio y atención',
            'Cumplimiento y Eficiencia',
            'Servicio Confiable y Oportuno',
            'Tiempos De Respuesta',
            'Ninguna',
        ],
        validation: (form) => {
            const value = Number(form.values.question6);
            return !isNaN(value) && value >= 9;
        },
    },
    {
        id: 'question9',
        type: 'unique',
        text: '8. ¿Cuál es la mejora más importante que podríamos realizar para obtener un resultado más cercano a 10?',
        options: [
            'Cumplir con las promesas',
            'Mejorar tiempos de respuesta',
            'Mayor Capacitación En Los Asesores Y/O Proveedores',
            'Mejorar la atención con el cliente',
            'Respuestas más claras y detalladas',
            'Buena asesoría por parte del agente',
            'Ninguna',
            'Claridad en la respuesta',
        ],
        validation: (form) => {
            const value = form.values.question6?.trim()
                ? Number(form.values.question6)
                : NaN;
            return !isNaN(value) && value <= 8;
        },
    },
];

export const questionsV2: Question[] = [
    {
        id: 'question1',
        type: 'scale',
        text: '1. En general ¿Qué tan satisfecho está con la experiencia vivida con el Defensor del Consumidor Financiero en la atención de su queja o reclamo?',
        options: ['1', '2', '3', '4', '5'],
        labels: ['Muy Insatisfecho', '', '', '', 'Muy Satisfecho'],
    },
    {
        id: 'question2',
        type: 'scale',
        text: '2. Por favor indíquenos su nivel de satisfacción relacionado con el proceso de Atención de su queja o reclamo. ¿La respuesta brindada por el Defensor del Consumidor Financiero fue clara y profesional?',
        options: ['1', '2', '3', '4', '5'],
        labels: ['Muy Insatisfecho', '', '', '', 'Muy Satisfecho'],
    },
    {
        id: 'question3',
        type: 'scale',
        text: '3. Por favor indíquenos su nivel de satisfacción relacionado con el proceso de Atención de su queja o reclamo. ¿El Defensor del Consumidor Financiero atendió de manera oportuna y efectiva su queja o reclamo?',
        options: ['1', '2', '3', '4', '5'],
        labels: ['Muy Insatisfecho', '', '', '', 'Muy Satisfecho'],
    },
    {
        id: 'question4',
        type: 'scale',
        text: '4. En una escala (1 a 5) donde 1 es muy sencillo y 5 es muy difícil, por favor califique ¿Qué tan sencillo fue realizar el trámite de su queja o reclamo a través del Defensor del Consumidor Financiero?',
        options: ['1', '2', '3', '4', '5'],
        labels: ['Muy Sencillo', '', '', '', 'Muy Difícil'],
    },
    {
        id: 'question5',
        type: 'unique',
        text: '5. ¿Qué mejora se debe implementar, para que el proceso de atención de la queja o reclamo por parte del Defensor del Consumidor sea el adecuado?',
        options: [
            'No Aplica',
            'No Informa',
            'Mejorar Tiempos De Respuesta Y Calidad Del Servicio',
            'Mejor Servicio',
            'Mas Personal Disponible',
            'Información Clara Y Oportuna',
            'Contestar el teléfono',
            'Claridad en la respuesta',
        ],
    },
    {
        id: 'question6',
        type: 'scale',
        text: '6. Basado en su experiencia en la atención de su queja o reclamo. ¿Qué tan dispuesto estaría usted de recomendar al Defensor del Consumidor Financiero de Previsora Seguros a un familiar, amigo o colega?',
        options: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
        labels: [
            'Poco Probable',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            'Muy Probable',
        ],
    },
    {
        id: 'question7',
        type: 'textarea',
        text: '¿Cuál es la principal razón por la que da esta calificación?, ¿Tiene alguna mejora importante que el Defensor del Consumidor Financiero deba realizar?',
    },
    {
        id: 'question8',
        type: 'unique',
        text: '7. ¿Cuál es la principal razón por la cual nos dio este puntaje?',
        options: [
            'Buen servicio y atención',
            'Cumplimiento y Eficiencia',
            'Servicio Confiable y Oportuno',
            'Tiempos De Respuesta',
            'Ninguna',
        ],
        validation: (form) => {
            const value = Number(form.values.question6);
            return !isNaN(value) && value >= 9;
        },
    },
    {
        id: 'question9',
        type: 'unique',
        text: '8. ¿Cuál es la mejora más importante que el Defensor del Consumidor Financiero podría realizar para obtener un resultado más cercano a 10?',
        options: [
            'Cumplir con las promesas',
            'Mejorar tiempos de respuesta',
            'Mayor Capacitación En Los Asesores Y/O Proveedores',
            'Mejorar la atención con el cliente',
            'Respuestas más claras y detalladas',
            'Buena asesoría por parte del agente',
            'Ninguna',
            'Claridad en la respuesta',
        ],
        validation: (form) => {
            const value = form.values.question6?.trim()
                ? Number(form.values.question6)
                : NaN;
            return !isNaN(value) && value <= 8;
        },
    },
    {
        id: 'question10',
        type: 'unique',
        text: '9. Considera que el Defensor del Consumidor Financiero conoció y resolvió su queja o reclamo de manera objetiva e imparcial, conforme a los procedimientos establecidos.',
        options: ['Si', 'No'],
    },
    {
        id: 'question11',
        type: 'unique',
        text: '10. Su queja o reclamo fue resulta de manera gratuita por parte del Defensor del Consumidor Financiero.',
        options: ['Si', 'No'],
    },
];

export const getQuestions = (half: string) => {
    half = half ? half.trim().toLowerCase() : '';
    if (half === 'defensor' || half === 'dcf')
        return {
            type: 'V2',
            questions: questionsV2,
        };

    return {
        type: 'V1',
        questions: questionsV1,
    };
};
